import { schemaTypes } from "../../../../constants/constants";
import _ from "lodash";
import ReportAPIs from "../../../../APIs/ReportAPIs";
import moment from "moment";
import { downloadCSV } from "../advancedFuelReport/advancedFuelReport";
import { getColValues } from "./RailwayReportWidget";

export const format = "DD.MMM.YYYY | HH:mm";

export const duration = (dur) => {
  if (!dur) return "--";
  // get hours & multiply fractional part by 60 to get minutes
  let hrs = dur / 1000 / 60 / 60;
  let min = parseInt((hrs % 1) * 60, 10);
  hrs = parseInt(hrs, 10);
  let els = min + " min";
  if (hrs > 0) els = hrs + " hrs " + els;
  return els;
};

export const roundNumber = (num) => {
  return num % 1 === 0 ? num : num.toFixed(2);
};

const getHistory = (schema, data, store) => {
  schema.content[0].ref.setBusy();
  let param = {
    userid: data.user[0].id,
    starttime: data.starttime.valueOf(),
    endtime: data.endtime.valueOf(),
  };
  ReportAPIs.getTrainHistory(param).then(
    (rsp) => {
      schema.content[0].ref.setData(rsp);
    },
    (err) => {
      if (err.response) {
        let rsp = err.response.data;
        console.error(rsp);
      }
      schema.content[0].ref.setData([]);
    }
  );
};

const changeUser = (u) => {
  this.selectedUser = u[0].data;
};

const selStorData = (state) => {
  let newMap = {};
  for (let idx in state.vehicleMap) {
    if (idx.indexOf("user") === 0) {
      newMap[idx] = state.vehicleMap[idx];
    }
  }
  return {
    data: newMap,
    name: "username",
    id: "userid",
  };
};

const userDefaultValue = (state) => {
  let newMap = {};
  for (let idx in state.vehicleMap) {
    if (idx.indexOf("user") === 0) {
      newMap[idx] = state.vehicleMap[idx];
    }
  }
  let usr = this.selectedUser;
  if (!this.userUpdatedAt) this.userUpdatedAt = Date.now();
  if (!this.selectedUser) {
    let id = Object.keys(newMap)[0];
    usr = newMap[id];
  }
  return {
    data: [usr.userid],
    updatedAt: this.userUpdatedAt,
  };
};

function downloadReport(schema) {
  let items = schema.content[0].ref.getData();
  let cols = [
    "Sr.",
    "Station Name",
    "Expected Arrival",
    "Actual Arrival",
    "Expected Departure",
    "Actual Departure",
    "Duration (hrs)",
    "Distance (kms)",
    "Max Speed (kmph)",
    "Avg Speed (kmph)",
    "Arrival Status",
    "Arrival Time Diff",
  ];
  let csv = "";
  for (let i in items) {
    let item = items[i];
    let start = item.stations[0];
    let dest = _.last(item.stations);
    csv +=
      [item.trainname, "", start.stationname, dest.stationname].join(",") +
      "\n";
    csv +=
      [
        "Train no",
        "Expected",
        moment(item.expstarttime).format(format),
        moment(item.expendtime).format(format),
        "Duration",
        "Distance",
        "Max speed",
        item.trainstatus,
      ] + "\n";
    csv +=
      [
        item.vehicleno,
        "Actual",
        moment(item.starttime).format(format),
        moment(item.endtime).format(format),
        duration(item.timetaken),
        roundNumber(item.distance),
        roundNumber(item.maxspeed),
        duration(item.statustime),
      ] + "\n";
    csv += cols.join(",") + "\n";
    csv +=
      item.stations
        .map((r, i) => {
          let row = getColValues(r, i)
            .map((r) => {
              return r[0];
            })
            .join(",");
          return row;
        })
        .join("\n") + "\n\n";
  }
  downloadCSV(csv, "railway_report");
}

const schema = {
  key: "railways_report",
  name: "Bangalore Division",
  toolbar: [
    {
      key: "user",
      type: schemaTypes.MULTI_SELECT,
      storeData: selStorData,
      onItemChange: changeUser,
      singleSelect: true,
      defaultValue: userDefaultValue,
    },
    {
      key: "starttime",
      type: schemaTypes.DATE_PICKER,
      setIfNull: true,
      placeholder: "Start Date",
      model: Date.now() - 1000 * 60 * 60 * 24,
    },
    {
      key: "endtime",
      type: schemaTypes.DATE_PICKER,
      setIfNull: true,
      placeholder: "End Date",
      model: moment(Date.now()).add(1, "day").startOf("day"),
    },
    {
      key: "get_history",
      type: schemaTypes.BUTTON,
      name: "Get Report",
      onClick: getHistory,
    },
    {
      key: "download",
      type: schemaTypes.BUTTON,
      iconType: "class",
      icon: "fa fa-download",
      onClick: downloadReport,
    },
  ],
  content: [
    {
      key: "data",
      type: schemaTypes.RAILWAY_REPORT_WIDGET,
      position: {
        width: 12,
        height: 12,
        left: 0,
        top: 0,
      },
    },
  ],
};
export default schema;
